import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import * as DOMPurify from 'dompurify';
import edit from "../../Images/edit.png";
import { myGlobals, myUtilities } from "../../Utils";
import { Subscribe } from "unstated";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import { callReduxAlertAction } from "../../App";
import { InvoiceGrid } from "./";

class InvoiceElements extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      takeInput: false,
      amount: parseFloat(0),
      showAlert: false,
    };
  }
  editOnClick = (data) => {
    if (
      myGlobals.checkPaymentContentSelected().localeCompare("SELECTION") !== 0
    )
      this.setState({
        showAlert: true,
      });
    else
      this.setState({
        amount: parseFloat(data.state.payableAmount),
        takeInput: true,
      });
  };
  onChangeEditField = (e) => {
    this.setState({
      amount: e.target.value,
    });
  };
  amountSubmitOnClick = async (data) => {
    if (
      myGlobals.checkPaymentContentSelected().localeCompare("SELECTION") !==
        0 ||
      this.state.amount < data.state.minAmount ||
      (this.state.amount > data.state.maxAmount &&
        data.state.maxAmount !== parseFloat(-1))
    ) {
      if (this.state.amount < 0)
        callReduxAlertAction(
          "Error.NegativePayableAmount",
          "Payable Amount should be positive to proceed"
        );
      else
        callReduxAlertAction(
          "Error.AmountNotInLimit",
          "Please enter value within limit"
        );
      this.setState({
        amount: parseFloat(data.state.payableAmount),
        takeInput: false,
      });
    } else {
      await data.setPayableAmount(this.state.amount);
      this.setState({
        takeInput: false,
      });
    }
  };
  showEditIcon = (data) => {
    if (this.props.showEditIcon) {
      return (
        <img
          src={edit}
          onClick={() => {
            this.editOnClick(data);
          }}
          className="edit-icon"
        />
      );
    }
  };

  setShow = (bool) => {
    this.setState({
      showAlert: bool,
    });
  };
  hint = (data) => {
    if (data.state.maxAmount === parseFloat(-1))
      return myUtilities.accountSpecificLanguage('InvoiceGrid.Message.AmountGreater', 'Please enter amount greater than ') + data.state.minAmount;
    else
      return (
        myUtilities.accountSpecificLanguage('InvoiceGrid.Message.AmountBetween', 'Please enter amount between ') +
        myUtilities.toStringUtil(data.state.minAmount, 'total') +
        myUtilities.accountSpecificLanguage('generic.Message.And', ' and ') +
        myUtilities.toStringUtil(data.state.maxAmount, 'total')
      );
  };
  displayToolTip = (props, data) => {
    if (data === undefined || data === null || data.localeCompare("null") === 0)
      return <div {...props} />;
    if (data.length > 30) return <Tooltip {...props}>{data}</Tooltip>;
    else return <div {...props} />;
  };

  formatData = (data) => {
    if (data === undefined || data === null || data.localeCompare("null") === 0)
      return "";
    if (data.length > 30) {
      return data.substring(0, 25) + "...";
    } else return data;
  };
  render() {
    if (this.state.showAlert) {
      return (
        <Modal
          show={this.state.showAlert}
          onHide={() => this.setShow(false)}
          centered
        >
          <Modal.Body>
            {myUtilities.accountSpecificLanguage('Error.Message.BackBeforeEdit', 'Please go back to payment selection page before trying to edit amount')}
          </Modal.Body>
        </Modal>
      );
    } else if (this.state.takeInput)
      return (
        <Subscribe to={[InvoiceDataContainer]}>
          {(data) => (
            <Container className="invoice-element-container">
              <Row className="row-separated-children">
                <Col className="invoice-element-header">
                  {this.props.header}
                </Col>
              </Row>
              <Row>
                <Col className="invoice-element-value">
                  <Form action="javascript:void(0);">
                    <Form.Group controlId="formBasicAmount">
                      <Form.Control
                        className="invoice-elements-form"
                        onChange={this.onChangeEditField}
                        value={this.state.amount}
                        type="number"
                      />
                      <Form.Text className="text-muted">
                        {this.hint(data)}
                      </Form.Text>
                    </Form.Group>
                    <Button
                      variant="primary"
                      onClick={() => {
                        this.amountSubmitOnClick(data);
                      }}
                      type="submit"
                      className = "mainapp-button"
                    >
                      {myUtilities.accountSpecificLanguage("submit", "Submit" )}
                    </Button>
                  </Form>
                </Col>
              </Row>
            </Container>
          )}
        </Subscribe>
      );
    else if (this.props.isPlain)
      return (
        <Container className="invoice-element-container">
          <Row className="row-separated-children">
            <Col className="invoice-element-header">{this.props.header}</Col>
          </Row>
          <Row>
            <OverlayTrigger
              key={this.props.header}
              placement={"top"}
              overlay={(props) => this.displayToolTip(props, this.props.value)}
            >
              <Col className="invoice-element-value-plain">
                { this.formatData(this.props.value)}
              </Col>
            </OverlayTrigger>
          </Row>
        </Container>
      );
    else if (!this.props.isGrid)
      return (
        <Subscribe to={[InvoiceDataContainer]}>
          {(data) => (
            <Container className={`invoice-element-container ${DOMPurify.sanitize(this.props.addClass)}`}>
              <Row className="row-separated-children">
                <Col className="invoice-element-header">
                  {this.props.header}
                </Col>
              </Row>
              <Row>
                <Col className="invoice-element-value">
                  {data.validateAndPopulateData(this.props.value, 35)}
                  {this.showEditIcon(data)}
                </Col>
              </Row>
            </Container>
          )}
        </Subscribe>
      );
    else
      return (
        <Container >
          <Row>
            <Col xs={12} sm={11}>
              <InvoiceGrid
                alterEditState={this.props.alterEditState}
                toshowEditWindow={this.props.toshowEditWindow}
              />
            </Col>
          </Row>
        </Container>
      );
  }
}

export default InvoiceElements;
